module.exports = "请提供一个尽可能精简的链接 [antd](https://codesandbox.io/s/2wpk21kzvr) 或是 GitHub 仓库的链接。\n<br>\n[什么是最小化重现，为什么这是必需的？](#repro-modal)\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh/reproHelp.md
// module id = 503
// module chunks = 0